import i18next from 'i18next';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';
import sortActionsList from '@commons/utils/sortActionsList';

/**
 * Header / bulk actions of the product B2B catalogs list. Without the edit right, the Add button
 * and the catalog mutations are hidden, leaving the export only.
 */
export const getActionsSettings = ({
  canEdit,
  selectedClients,
  handleAddToCatalogs,
  handleEditPrices,
  handleRemoveFromCatalogs,
  handleExport,
}) => {
  const hasSelection = selectedClients.length > 0;

  const actions = [
    {
      id: 'action-add',
      fixed: true,
      actionLabel: i18next.t('GENERAL.ADD'),
      isHidden: () => !canEdit,
      handleAction: handleAddToCatalogs,
      render: () => (
        <Button
          color={'inpulse-default'}
          handleClick={handleAddToCatalogs}
          icon={'/images/inpulse/add-white-small.svg'}
          label={i18next.t('GENERAL.ADD')}
        />
      ),
    },
    {
      id: 'edit-prices',
      actionLabel: i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_EDIT_PRICES'),
      actionIcon: () => '/images/inpulse/pen-black-small.svg',
      isHidden: () => !canEdit || !hasSelection,
      handleAction: () => handleEditPrices(selectedClients),
    },
    {
      id: 'delete-remove-from-catalogs',
      actionLabel: i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_REMOVE_FROM_CATALOGS'),
      actionIcon: () => '/images/inpulse/trash-black-small.svg',
      isHidden: () => !canEdit || !hasSelection,
      handleAction: () => handleRemoveFromCatalogs(selectedClients),
    },
    {
      id: 'export-external-clients',
      actionLabel: i18next.t(hasSelection ? 'GENERAL.EXPORT_SELECTION' : 'GENERAL.EXPORT_LIST'),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
      handleAction: handleExport,
    },
  ];

  return sortActionsList(actions.filter(({ isHidden }) => !isHidden?.()));
};

/** Row actions (price edit / catalog removal), hidden without the edit right. */
export const getRowActionsSettings = ({ canEdit, handleEditPrices, handleRemoveFromCatalogs }) => {
  if (!canEdit) {
    return [];
  }

  return [
    {
      id: 'edit-price',
      actionLabel: () => i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_EDIT_PRICE'),
      actionIcon: () => '/images/inpulse/pen-black-small.svg',
      handleAction: (externalClient) => handleEditPrices([externalClient]),
    },
    {
      id: 'delete-remove-from-catalog',
      actionLabel: () => i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_REMOVE_FROM_CATALOG'),
      actionIcon: () => '/images/inpulse/trash-black-small.svg',
      handleAction: (externalClient) => handleRemoveFromCatalogs([externalClient]),
    },
  ];
};

export default { getActionsSettings, getRowActionsSettings };
